<template>
  <v-row>
    <v-card tile width="700" class="mx-auto secundary5 mt-n4">
      <v-data-table
        :headers="headersTable"
        :items="coList.correctors"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        dense
        hide-default-footer
        class="elevation-1 secundary5"
        @page-count="pageCount = $event"
      >
        <template v-slot:top>
          <v-dialog v-model="dialogDelete" max-width="350px">
            <v-card>
              <v-card-title class="text-body-1">¿Seguro que desea eliminar este item?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="deleteItemPre()">Eliminar</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon size="x-large" class="mr-7" @click="downloadItem(item)">
            mdi-cloud-download
          </v-icon>
          <v-icon size="large" class="mr-7" @click="editItem(item)" v-if="observerHCP === false">
            mdi-pencil
          </v-icon>
          <v-icon size="large" @click="deleteItemDialog(item)" v-if="observerHCP === false">
            mdi-delete
          </v-icon>
        </template>
      </v-data-table>
      <div class="d-flex justify-space-between">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
      </div>
      <v-card-actions class="d-flex justify-end mt-n5">
        <v-col class="d-flex justify-end pt-0 mb-2 px-0" v-if="observerHCP === true"></v-col>
        <v-col class="d-flex justify-end pt-0 mb-2 px-0" v-else>
          <span class="text-subtitle-2 mr-7"> Agregar: </span>
          <div class="d-flex justify-center mx-1" v-for="(btn, index) in coBtnAdd" :key="index">
            <div v-if="btn.soon == false">
              <v-btn small color="blue darken-1" text @click="insertRoute(btn.to)">
                {{ btn.name }}
              </v-btn>
            </div>
            <div v-else>
              <v-btn
                small
                color="blue darken-1"
                text
                @click="insertRoute(btn.to)"
                class="grey--text lighten-3 pl-2 pr-1"
              >
                {{ btn.name }}
                <v-chip
                  color="transparent"
                  class="primary3--text text-lowercase px-0 mb-4"
                  x-small
                  v-if="coBtnAdd[1].open == true"
                >
                  {{ btn.alert }}
                </v-chip>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-card-actions>
      <v-row> </v-row>
      <v-row class="mt-3" v-if="isRoute">
        <span class="secundary5--text lighten-3"> .</span>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>

export default {
  name: 'VTableCorrectorsDone',
  props: [
    'headersTable',
    'coList',
    'coBtnAdd',
    'coBtnIcons',
    'slideDialogItem',
    'clickTo',
    'editItem',
    'deleteItem',
    'observerHCP',
    'downloadItem',
  ],
  data() {
    return {
      length: 2,
      onboarding: 0,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dialog: false,
      dialogDelete: false,
    };
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
    close() {
      this.dialog = false;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    deleteItemDialog(item) {
      this.dialogDelete = true;
      this.item = item;
    },
    deleteItemPre() {
      const item = this.item;
      this.deleteItem(item);
      this.dialogDelete = false;
    },
  },
  computed: {
    isRoute() {
      return this.$route.name === 'list';
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>
